<script>
  import { Howl } from "howler";
  import { onMount } from "svelte";
  let isViewingEffect = false;

  const sound = new Howl({
    src: "/register.mp3",
    html5: true,
  });

  /**
   * レベルアップ時にエフェクトを表示
   */
  export const viewLevelUpEffect = () => {
    isViewingEffect = true;
    sound.play();
    setTimeout(() => {
      isViewingEffect = false;
    }, 2000);
  };

  onMount(async () => {});
</script>

<div class="container {isViewingEffect ? 'animation' : ''}">
  <img src={"/levelup.png"} alt="levelUp" />
</div>

<style lang="scss">
  .container {
    position: absolute;
    top: 0;
    left: 100%;
    width: 100%;
    height: 100%;
    z-index: 2;
    text-align: center;
    opacity: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 85%;
      max-width: 500px;
    }
  }

  .animation {
    animation-name: levelUpAnimation;
    animation-duration: 4s;
  }

  @keyframes levelUpAnimation {
    from {
      opacity: 0;
    }
    0% {
      left: -100%;
    }
    10% {
      opacity: 1;
      left: 0%;
    }
    35% {
      left: 0%;
      opacity: 1;
    }
    45% {
      left: 100%;
      opacity: 0;
    }
  }
</style>
